import { useSyncExternalStore } from 'react';

/**
 * Maintenance-mode flag as a module store (not Context) because it must be
 * settable from outside React — the axios interceptor flips it on when the
 * backend responds 503 (src/api/client.ts).
 */

let isMaintenanceMode = false;
const listeners = new Set<() => void>();

export const setMaintenanceMode = (value: boolean): void => {
  if (isMaintenanceMode === value) return;
  isMaintenanceMode = value;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = (): boolean => isMaintenanceMode;

export const useMaintenanceMode = (): boolean => useSyncExternalStore(subscribe, getSnapshot);
